export function timeAgo(iso) {
  if (!iso) return "";
  const seconds = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (seconds < 60) return "just now";
  const intervals = [
    { l: "y", s: 31536000 },
    { l: "mo", s: 2592000 },
    { l: "w", s: 604800 },
    { l: "d", s: 86400 },
    { l: "h", s: 3600 },
    { l: "m", s: 60 },
  ];
  for (const i of intervals) {
    const c = Math.floor(seconds / i.s);
    if (c >= 1) return `${c}${i.l} ago`;
  }
  return "just now";
}
